export default __webpack_public_path__ + "static/media/escalera4.feaa6f8f.png";